export default "/assets/images/mini-nav-menu.7e00135b7b48ac0a.webp";